module.exports = __webpack_public_path__ + "img/pill_completado_image.7b39e8cc.svg";